import React from "react";
import TopBar from "../components/TopBar";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Philosophy from "../components/Philosophy";
import Curriculum from "../components/Curriculum";
import Programs from "../components/Programs";
import Campus from "../components/Campus";
import Testimonials from "../components/Testimonials";
import VisitTeaser from "../components/VisitTeaser";
import Contact from "../components/Contact";
import SectionCurve from "../components/SectionCurve";

/**
 * Cool pastel palette (blues, greens, cream) flowing between sections:
 *  Hero      → #FAFAF5 (cream / off-white)
 *  Philosophy→ #E3EDF9 (powder sky)
 *  Curriculum→ #FAFAF5 (cream)
 *  Programs  → #E8F1DF (sage)
 *  Campus    → #FAFAF5 (cream)
 *  Testimon. → #0F1B47 (navy)
 *  VisitTease→ #DCEFE1 (mint)
 *  Contact   → #E3EDF9 (powder sky)
 *
 * SectionCurve: `bg` = colour of the section ABOVE (the strip),
 *               `fill` = colour of the section BELOW (the curve).
 */
export default function Home() {
  return (
    <div className="bg-[#FAFAF5] min-h-screen" data-testid="home-page">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <SectionCurve bg="#FAFAF5" fill="#E3EDF9" variant="wave" />
        <Philosophy />
        <SectionCurve bg="#E3EDF9" fill="#FAFAF5" variant="tilt" />
        <Curriculum />
        <SectionCurve bg="#FAFAF5" fill="#E8F1DF" variant="wave" flip />
        <Programs />
        <SectionCurve bg="#E8F1DF" fill="#FAFAF5" variant="smile" />
        <Campus />
        <SectionCurve bg="#FAFAF5" fill="#0F1B47" variant="wave" />
        <Testimonials />
        <SectionCurve bg="#0F1B47" fill="#DCEFE1" variant="tilt" flip />
        <VisitTeaser />
        <SectionCurve bg="#DCEFE1" fill="#E3EDF9" variant="wave" />
        <Contact />
      </main>
    </div>
  );
}
